import { render, staticRenderFns } from "./SystemSpecifications.vue?vue&type=template&id=4d57a42b&scoped=true"
import script from "./SystemSpecifications.vue?vue&type=script&lang=js"
export * from "./SystemSpecifications.vue?vue&type=script&lang=js"
import style0 from "./SystemSpecifications.vue?vue&type=style&index=0&id=4d57a42b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d57a42b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})
